var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newsletter"},[_c('h2',{staticClass:"title-font",domProps:{"innerHTML":_vm._s(_vm.title)}}),(_vm.content)?_c('custom-form',{attrs:{"content":_vm.content}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }